import { render, staticRenderFns } from "./ActiveGrantFilterList.vue?vue&type=template&id=1b189be6&scoped=true&"
import script from "./ActiveGrantFilterList.vue?vue&type=script&lang=js&"
export * from "./ActiveGrantFilterList.vue?vue&type=script&lang=js&"
import style0 from "./ActiveGrantFilterList.vue?vue&type=style&index=0&id=1b189be6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b189be6",
  null
  
)

export default component.exports